module.exports = __webpack_public_path__ + "img/three-dots.74166881.svg";